import "./SelectCarrera.css";
import { useDispatch, useSelector } from "react-redux";
import {
  selectStudent,
  setCarrearActual,
  setStudentMostrarHorarios,
  setStudentMostrarAulas,
  setToken,
} from "../../reduxSlices/studentSlice";
import SlDropdown from "@shoelace-style/shoelace/dist/react/dropdown";
import SlMenu from "@shoelace-style/shoelace/dist/react/menu";
import SlMenuItem from "@shoelace-style/shoelace/dist/react/menu-item";
import SlIcon from "@shoelace-style/shoelace/dist/react/icon";
import SlIconButton from "@shoelace-style/shoelace/dist/react/icon-button";
import { CarreraItem, EstadoLoginStudent } from "../../types";
import { useNavigate } from "react-router-dom";
import { postSeleccionaCarrera } from "../../Api/authentication";
import Translatable from "../Translatable/Translatable";
import {
  getIpoNotInWhitelistMessage,
  isIpoNotInWhitelistError,
  scheduleAutoLogout,
} from "../../utils/authHelpers";
import { showToastError } from "../../hooks/useToast";

export default function SelectCarrera() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { carreraActual, listadoCarreras } = useSelector(selectStudent);

  async function seleccionaCarrera(idAlu: number, nombreCarrera: string) {
    const res: EstadoLoginStudent = await postSeleccionaCarrera(idAlu);

    if (res?.error) {
      if (isIpoNotInWhitelistError(res.error)) {
        showToastError(getIpoNotInWhitelistMessage(res.error));
      } else {
        showToastError("Error al seleccionar la carrera, por favor intente nuevamente.");
      }
      return;
    }

    const { token, mostrarHorarios, mostrarAulas } = res;

    dispatch(setCarrearActual(nombreCarrera));
    
    localStorage.removeItem("CUPO_CURSOS_SYNCED");
    ingresarEnApp(token, mostrarHorarios, idAlu, mostrarAulas);
  }

  async function ingresarEnApp(
    token: string,
    mostrarHorarios: boolean,
    idAP?: number,
    mostrarAulas?: boolean
  ) {
    localStorage.setItem("token", token);
    dispatch(setToken(token));
    scheduleAutoLogout(token);
    if (idAP) localStorage.setItem("idAP", JSON.stringify(idAP));
    if (mostrarHorarios) dispatch(setStudentMostrarHorarios(mostrarHorarios));
    if (typeof mostrarAulas === "boolean") dispatch(setStudentMostrarAulas(mostrarAulas));
    navigate(0);
  }

  return (
    <div className="select-carrera-container">
      {carreraActual && (
        <p>
          <Translatable as="span" className="carrera-actual">{carreraActual}</Translatable>
        </p>
      )}
      {listadoCarreras?.length > 1 && (
        <SlDropdown>
          <SlIconButton slot="trigger" className="list" name="chevron-down" label="Menu"></SlIconButton>
          <SlMenu className="carrera-menu">
            {listadoCarreras.map((item: CarreraItem) => {
              const isSelected = carreraActual == item.descripcionCarrera;
              return (
                <SlMenuItem
                  key={item.descripcionCarrera}
                  onClick={() => seleccionaCarrera(item.idAlumnoPrograma, item.descripcionCarrera)}
                >
                  <Translatable
                    as="span"
                    className={`carrera-item-text${isSelected ? " selected-carrera-item" : ""}`}
                    capitalize={false}
                  >
                    {item.descripcionCarrera}
                  </Translatable>
                  {isSelected && <SlIcon slot="suffix" name="check-lg"></SlIcon>}
                </SlMenuItem>
              );
            })}
          </SlMenu>
        </SlDropdown>
      )}
    </div>
  );
}
